var instructions = 'Refresh the page and try again, and if the problem continues, please contact an administrator';
function withResponseErrorHandling(responsePromise, action, setNumLoading, setError, setAllEmpty) {
  setNumLoading(function (v) {
    return v + 1;
  });
  setAllEmpty && setAllEmpty();
  return responsePromise.then(function (response) {
    setNumLoading(function (v) {
      return v - 1;
    });
    if (response && (response.status === "OK" || response.status === 200 || response.status === true)) {
      //all good
    } else if (response && response.status === "ERROR") {
      setError({
        title: "Error ".concat(action),
        instructions: instructions,
        trace: response.message
      });
    } else if (response && response.status === "WARN") {
      setError({
        variant: 'warning',
        title: "Error ".concat(action),
        instructions: instructions,
        trace: response.message
      });
    } else if (response && response.status === 'DENIED') {
      setError({
        variant: 'denied',
        title: response.title,
        instructions: instructions,
        trace: response.message
      });
    } else if (response && response.location === '/') {
      // logout succesfully
    } else {
      setError({
        title: "Unexpected ".concat(action),
        instructions: instructions,
        trace: JSON.stringify()
      });
    }
    return response;
  }).catch(function (e) {
    console.error("Response error on ".concat(action), e);
    setNumLoading(function (v) {
      return v - 1;
    });
    setError({
      title: "Unexpected error ".concat(action, ": ").concat(e.name),
      instructions: instructions,
      trace: (e || {}).message
    });
    throw e;
  });
}
export { withResponseErrorHandling };